/** Enforcing theme tokens to be used for porsche */
const themeTokens = {
    primaryColor: '#d5001c',
    hoveredPrimaryColor: '#980014',

    linkColor: '#000000',
    hoveredLinkColor: '#d5001c',

    secondaryColor: '#323639',
    hoveredSecondaryColor: '#151718',

    tertiaryColor: '#323639',
    hoveredTertiaryColor: '#151718',

    disabledColor: '#96989a',
    disabledTextColor: '#ffffff8c',

    textColor: '#000000',

    baseFontSize: '1rem',
    buttonFontSize: '1rem',
    inputFontSize: '1rem',

    inputFieldHeight: '48px',
};

export default themeTokens;
